// @ts-nocheck
import { blockAllTrackers } from '@/lib/tracking';
import { handleError } from '@/utilities';
import store from '@/store';

/**
 * Kicks off the block trackers process. Initializes the site trackers array by
 * setting the regex property on each tracker object to a new RegExp object that
 * is based on the pattern property of the tracker object. Then calls the
 * blockAllTrackers function with the new site trackers array.
 *
 * @param {Object} config
 * @returns
 */
export function blockTrackers(config) {
  try {
    const {
      regionTemplate: {
        settings: { consent: { blockingMode = 'disabled' } = {} } = {},
      } = {},
      trackers = [],
    } = config;

    if (blockingMode === 'disabled') {
      return;
    }
    store.setKnownTrackers(trackers);
    blockAllTrackers();
  } catch (err) {
    handleError(err);
  }
}
